import { Alert } from '../../renderApp/components/cells/Alert/Alert';
import { Confirm } from '../../renderApp/components/cells/Confirm/Confirm';
import { RedirectErrorJson } from '../type/error_json';
import { preventEscapeErrorJson } from '../util/preventEscapeErrorJson';

export class ClientError extends Error {
  constructor(public json: { title: string; message?: string }) {
    super(json.title);
  }
}

export const errorDialogOpen = async ({
  title,
  message,
  type,
  confirmText,
  cancelText,
}: RedirectErrorJson) => {
  if (type === 'confirm') {
    return await Confirm.open(
      preventEscapeErrorJson({
        title,
        message,
        confirmText,
        cancelText,
      }),
    );
  }

  await Alert.open(
    preventEscapeErrorJson({
      title,
      message,
      confirmText,
      cancelText,
    }),
  );
};
